import SimpleBar from 'simplebar';
import 'simplebar/dist/simplebar.css';


// Handle reinit on custom event
document.body.addEventListener('bw-custom-scroll-reload', () => {
    console.log("init");

    initCustomScroll();
})

function initCustomScroll() {
    // Find all elements where custom scroll should be initialized
    const scrollsContainers = document.querySelectorAll(`[data-custom-scroll='init']`);
    if (scrollsContainers.length > 0) {
        scrollsContainers.forEach(container => {
            // Check if custom srcoll has ben alread init on this container
            if (container.getAttribute("data-custom-scroll-active") != "true") {
                container.setAttribute("data-custom-scroll-active", "true");

                new SimpleBar(container, { autoHide: false });
            }
        })
    }

    // Find all elements where custom scroll should be initialized
    const scrollsContainersYLPopups = document.querySelectorAll(`[data-item="bw-popup-youlead"]`);
    if (scrollsContainersYLPopups.length > 0) {
        scrollsContainersYLPopups.forEach(container => {
            // Check if custom srcoll has ben alread init on this container
            if (container.getAttribute("data-custom-scroll-active") != "true") {
                container.setAttribute("data-custom-scroll-active", "true");

                new SimpleBar(container, { autoHide: false });
            }
        })
    }
}
